import { forwardRef } from 'react';
import turfDistance from '@turf/distance';
import { pointItemToLngLat } from '@alltrails/maps/utils/legacyGeoJSONConversions';
import { FormattedMessage, useIntl, defineMessages } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import AlgoliaSearchBox from '../../../../components/AlgoliaSearchBox';
import { OptionButtons } from './option_buttons';
import { RegionAndCountrySelect } from './region_and_country_select';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { VerifiedRouteContributeItem } from './verified_route_contribute_item';
import { MapStatsUtil } from '../../../../utils/map_stats_util';
import ActivityUploadModal from '../../../../components/forms/ActivityUploadModal';
import { PARK_SELECTION, TRAIL_DETAILS } from '../../../../utils/constants/SearchAnalyticsConstants';
import { getPrimaryIndex } from '../../../../utils/search';
import PortalModal from 'components/shared/PortalModal';
import {
  FILTER_ACCESS_STRINGS,
  FILTER_ACTIVITIES_STRINGS,
  FILTER_FEATURE_TYPES_STRINGS,
  FILTER_OBSTACLES_STRINGS
} from '../../../../utils/filters/filters.strings';

const createReactClass = require('create-react-class');

const METERS_TO_MILES = 0.000621371;

// Same as server-side constant:
const CENTER_LOWER_48 = [39.8282102, -98.581832];

const monthMessages = defineMessages({
  January: { defaultMessage: 'January' },
  February: { defaultMessage: 'February' },
  March: { defaultMessage: 'March' },
  April: { defaultMessage: 'April' },
  May: { defaultMessage: 'May' },
  June: { defaultMessage: 'June' },
  July: { defaultMessage: 'July' },
  August: { defaultMessage: 'August' },
  September: { defaultMessage: 'September' },
  October: { defaultMessage: 'October' },
  November: { defaultMessage: 'November' },
  December: { defaultMessage: 'December' }
});

const BaseTrailDetailsBox = createReactClass({
  getInitialState() {
    let areaId;
    if (this.props.trail.area) {
      areaId = this.props.trail.area.id;
    }
    let cityId;
    if (this.props.trail.location) {
      cityId = this.props.trail.location.city_id;
    }

    let activities = {};
    let obstacles = {};
    let features = {};
    if (this.props.trail.attributes.activities.length > 0)
      activities = this.props.trail.attributes.activities.reduce((map, act) => {
        map[act.uid] = act;
        return map;
      }, {});
    if (this.props.trail.attributes.obstacles.length > 0)
      obstacles = this.props.trail.attributes.obstacles.reduce((map, act) => {
        map[act.uid] = act;
        return map;
      }, {});
    if (this.props.trail.attributes.features.length > 0)
      features = this.props.trail.attributes.features.reduce((map, act) => {
        map[act.uid] = act;
        return map;
      }, {});
    this.originalActivities = $.extend({}, activities);
    this.originalFeatures = $.extend({}, features);
    this.originalObstacles = $.extend({}, obstacles);
    if (
      this.props.useMapAsRoute &&
      this.props.useMapAsRoute.tracks &&
      this.props.useMapAsRoute.tracks[0] &&
      this.props.useMapAsRoute.tracks[0].activity
    ) {
      activities[this.props.useMapAsRoute.tracks[0].activity.uid] = this.props.useMapAsRoute.tracks[0].activity;
    }
    return {
      difficultyRating: this.props.trail.defaultActivityStats.difficulty,
      visitorUsage: this.props.trail.defaultActivityStats.visitorUsage,
      location: { latitude: '', longitude: '' },
      allActivities: [],
      allObstacles: [],
      allFeatures: [],
      allAccessibility: [],
      checkedActivities: activities,
      checkedFeatures: features,
      checkedObstacles: obstacles,
      areaId,
      cityId,
      nearbyCities: [],
      nearbyParks: [],
      description: this.getDescription(),
      name: this.props.trail.name || this.props.useMapAsRoute?.name || ''
    };
  },
  handleError() {},
  handleComplete() {},
  componentDidMount() {
    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/trails/attributes',
      {},
      this.handleAllActivitiesLoad,
      this.handleError,
      this.handleComplete
    );

    let areaText;
    let cityText;
    let cityLocation;

    const trailLngLat = pointItemToLngLat(this.props.trail);
    if (trailLngLat) {
      // Set city-relevant info
      const cityDistanceTo = this.props.currentCity ? turfDistance(trailLngLat, pointItemToLngLat(this.props.currentCity)) * 1000 : 0;
      cityText = `${this.props.trail.location.city} (${this.metersToFormattedUserUnits(cityDistanceTo)})`;
      cityLocation =
        (this.props.trail.location.regionName ? `${this.props.trail.location.regionName}, ` : '') + this.props.trail.location.country_name;
      // Set area-relevant info
      if (this.props.trail.area) {
        const areaDistanceTo = turfDistance(trailLngLat, pointItemToLngLat(this.props.trail.area)) * 1000;
        areaText = `${this.props.trail.area.name} (${this.metersToFormattedUserUnits(areaDistanceTo)})`;
      }
    }

    const latitude = Math.round(parseFloat(trailLngLat[1]) * 10000000) / 10000000;
    const longitude = Math.round(parseFloat(trailLngLat[0]) * 10000000) / 10000000;

    if (!this.listeners) {
      this.listeners = [];
    }
    this.algoliaIndex = getPrimaryIndex(this.props.languageRegionCode);

    this.setState(
      {
        location: { latitude, longitude },
        areaText,
        cityText,
        cityLocation
      },
      this.algoliaParksAndCityQuery
    );
  },
  componentDidUpdate(prevProps) {
    const routeInfo = this.props.routeInfo;
    if (prevProps.routeInfo && routeInfo && routeInfo.routeStartPt && routeInfo !== prevProps.routeInfo) {
      this.handleTrailHeadMoved(routeInfo.routeStartPt);
    }
  },
  componentWillUnmount() {
    for (let i = 0; i < this.listeners.length; i++) {
      this.listeners[i].unsubscribe();
    }
  },
  algoliaParksAndCityQuery() {
    this.algoliaParksAndCityQueryLatLng(this.state.location.latitude, this.state.location.longitude);
  },
  algoliaParksAndCityQueryLatLng(lat, lng) {
    this.algoliaIndex
      .search('', {
        aroundLatLng: `${lat},${lng}`,
        aroundRadius: 1000000,
        getRankingInfo: 1,
        facets: ['type'],
        facetFilters: ['type:area'],
        hitsPerPage: 1000
      })
      .then(this.handleParkResults)
      .catch(err => console.error(err));
    this.algoliaIndex
      .search('', {
        aroundLatLng: `${lat},${lng}`,
        aroundRadius: 200000,
        getRankingInfo: 1,
        facets: ['type'],
        facetFilters: ['type:place'],
        hitsPerPage: 100
      })
      .then(this.handleCityResults)
      .catch(err => console.error(err));
  },
  // Remove a given set of attributes from a list
  filterAttributes(attrList, removeAttrList) {
    const attrs = attrList.filter(item => {
      // Need css for last 2
      if (removeAttrList.indexOf(item.uid) >= 0) return false;
      return true;
    });
    return attrs;
  },
  handleAllActivitiesLoad(data) {
    const removedActivities = ['default', 'geocaching', 'mountaineering', 'nature-trips'];
    const removedFeatures = ['dogs', 'dogs-leash', 'dogs-no', 'kids'];
    const accessibleFeatures = ['ada', 'paved', 'partially-paved', 'strollers'];
    const removedObstacles = ['flooded', 'great', 'icy', 'old-growth', 'slippery'];

    const activities = this.filterAttributes(data.activities, removedActivities);
    activities.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
    // accesibility tags come down as features, so filter them out separately
    const features = this.filterAttributes(data.features, removedFeatures.concat(accessibleFeatures));
    const accessibles = data.features.filter(item => {
      return accessibleFeatures.indexOf(item.uid) > -1;
    });
    const obstacles = this.filterAttributes(data.obstacles, removedObstacles);

    this.setState({
      allActivities: activities,
      allFeatures: features,
      allObstacles: obstacles,
      allAccessibility: accessibles
    });
  },
  handleTrailHeadMoved(lngLatLike) {
    const latitude = Math.round(parseFloat(lngLatLike[1]) * 10000000) / 10000000;
    const longitude = Math.round(parseFloat(lngLatLike[0]) * 10000000) / 10000000;
    this.setState({
      location: { latitude, longitude }
    });
    this.algoliaParksAndCityQueryLatLng(latitude, longitude);
    if (this.state.cityId == -2) {
      this.updateTrailHeadGeocode();
    }
  },
  updateTrailHeadGeocode() {
    this.setState({ geocodedCityText: this.props.intl.formatMessage({ defaultMessage: 'loading...' }) });
    const revGeocodeUrl = '/api/alltrails/locations/reverse_geocode_city';
    const successFunc = (data, status, xhr) => {
      if (data && data.name) {
        this.setState({ geocodedCityText: data.name });
      }
    };
    const errorFunc = () => {
      this.setState({ geocodedCityText: this.props.intl.formatMessage({ defaultMessage: 'an error occurred' }) });
    };
    const completeFunc = () => {};
    if (this.revGeocodeRequest) {
      this.revGeocodeRequest.abort();
      this.revGeocodeRequest = null;
    }
    const params = {
      latitude: this.state.location.latitude,
      longitude: this.state.location.longitude
    };
    this.revGeocodeRequest = ServerCommunicationUtil.postApiEndpoint(revGeocodeUrl, params, successFunc, errorFunc, completeFunc);
  },
  handleCityChange(e) {
    const cityId = parseInt(e.currentTarget.value);
    if (cityId === -2) {
      this.updateTrailHeadGeocode();
    }
    const city = this.state.nearbyCities.filter(c => {
      return c[0] == cityId;
    });
    let cityText = null;
    let cityLocation = null;
    if (city && city[0]) {
      // Do not keep distance-to as will likely be different when this is re-displayed
      cityText = city[0][1].replace(/ \(.*mi\)$/, '');
      cityLocation = city[0][2];
    }
    this.setState({ cityId, cityText, cityLocation });
  },
  getSelectedActivities() {
    const selectedActivities = [];
    Object.keys(this.state.checkedActivities).forEach((key, idx) => {
      selectedActivities.push(this.state.checkedActivities[key].uid);
    });
    return selectedActivities;
  },
  getNameEdit() {
    return { type: 'name', data: { name: this.state.name } };
  },
  getDifficultyEdit() {
    return this.refs.difficultyRating.getSelectedOptionValue();
  },
  getAllTrailEdits() {
    const allEdits = [];
    if (this.state.name != this.props.trail.name) {
      allEdits.push(this.getNameEdit());
    }
    let seasonStart;
    let seasonEnd;
    seasonStart = parseInt(this.refs.seasonStart.value);
    if (isNaN(seasonStart)) {
      seasonStart = -1;
    }
    seasonEnd = parseInt(this.refs.seasonEnd.value);
    if (isNaN(seasonEnd)) {
      seasonEnd = -1;
    }

    if (seasonStart != this.props.trail.defaultActivityStats.seasonStart) {
      allEdits.push({ type: 'season_start', data: { month: seasonStart } });
    }

    if (seasonEnd != this.props.trail.defaultActivityStats.seasonEnd) {
      allEdits.push({ type: 'season_end', data: { month: seasonEnd } });
    }

    if (!this.props.isPendingTrail || this.props.trail.canEdit) {
      if (this.refs.length.value != MapStatsUtil.metersToMiles(this.props.trail.trailGeoStats.length)) {
        allEdits.push({ type: 'length', data: { length: parseFloat(this.refs.length.value) } });
      }
    }

    if (this.refs.key_points && this.refs.key_points.value != this.getAdminNotes()) {
      allEdits.push({ type: 'trail_detail', data: { name: 'key_points', value: this.refs.key_points.value } });
    }

    if (this.refs.description && this.refs.description.value != this.getDescription()) {
      allEdits.push({ type: 'trail_detail', data: { name: 'description', value: this.refs.description.value } });
    }

    const newDr = this.refs.difficultyRating.getSelectedOptionValue();
    if (newDr != this.convertDifficultyRating(this.props.trail.defaultActivityStats.difficulty)) {
      allEdits.push({ type: 'difficulty_rating', data: { difficultyRating: parseInt(newDr) } });
    }
    const newVu = this.refs.visitorUsage.getSelectedOptionValue();
    if (newVu != this.props.trail.defaultActivityStats.visitorUsage) {
      allEdits.push({ type: 'visitor_usage', data: { visitorUsage: parseInt(newVu) } });
    }

    const newRt = this.refs.routeType.getSelectedOptionValue();
    if (newRt && this.props.trail.routeType == null) allEdits.push({ type: 'route_type', data: { routeType: newRt } });
    else if (newRt != null && newRt != this.props.trail.routeType.uid) allEdits.push({ type: 'route_type', data: { routeType: newRt } });

    if (Object.keys(this.state.checkedActivities) != Object.keys(this.originalActivities)) {
      Object.keys(this.state.checkedActivities).forEach((key, idx) => {
        if (Object.keys(this.originalActivities).indexOf(key) < 0) {
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'Y' },
            relation_id: this.state.checkedActivities[key].uid
          });
        }
      });
      Object.keys(this.originalActivities).forEach((key, idx) => {
        if (Object.keys(this.state.checkedActivities).indexOf(key) < 0) {
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'N' },
            relation_id: this.originalActivities[key].uid
          });
        }
      });
    }
    if (Object.keys(this.state.checkedFeatures) != Object.keys(this.originalFeatures)) {
      Object.keys(this.state.checkedFeatures).forEach((key, idx) => {
        if (Object.keys(this.originalFeatures).indexOf(key) < 0)
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'Y' },
            relation_id: this.state.checkedFeatures[key].uid
          });
      });
      Object.keys(this.originalFeatures).forEach((key, idx) => {
        if (Object.keys(this.state.checkedFeatures).indexOf(key) < 0) {
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'N' },
            relation_id: this.originalFeatures[key].uid
          });
        }
      });
    }
    if (Object.keys(this.state.checkedObstacles) != Object.keys(this.originalObstacles)) {
      Object.keys(this.state.checkedObstacles).forEach(
        function (key, idx) {
          if (Object.keys(this.originalObstacles).indexOf(key) < 0)
            allEdits.push({
              type: 'attribute',
              data: { allowed: 'Y' },
              relation_id: this.state.checkedObstacles[key].uid
            });
        }.bind(this)
      );
      Object.keys(this.originalObstacles).forEach(
        function (key, idx) {
          if (Object.keys(this.state.checkedObstacles).indexOf(key) < 0) {
            allEdits.push({
              type: 'attribute',
              data: { allowed: 'N' },
              relation_id: this.originalObstacles[key].uid
            });
          }
        }.bind(this)
      );
    }
    // Handle the features we pulled out from the list
    const originalFeatureKeys = Object.keys(this.originalFeatures);
    const new_value = this.refs.dogs.getSelectedOptionValue();
    if (new_value != this.getDogsValue(this.originalFeatures)) {
      let dogs = 'U';
      let dogs_leash = 'U';
      let dogs_no = 'U';
      switch (new_value) {
        case 'L':
          dogs_leash = 'Y';
          break;
        case 'Y':
          dogs = 'Y';
          break;
        case 'N':
          dogs_no = 'Y';
          break;
        default:
          break;
      }
      allEdits.push({ type: 'attribute', data: { allowed: dogs }, relation_id: 'dogs' });
      allEdits.push({
        type: 'attribute',
        data: { allowed: dogs_leash },
        relation_id: 'dogs-leash'
      });
      allEdits.push({ type: 'attribute', data: { allowed: dogs_no }, relation_id: 'dogs-no' });
    }
    // Kids
    if (originalFeatureKeys.indexOf('kids') >= 0 && this.refs.kids.getSelectedOptionValue() == null)
      allEdits.push({ type: 'attribute', data: { allowed: 'N' }, relation_id: 'kids' });
    else if (originalFeatureKeys.indexOf('kids') < 0 && this.refs.kids.getSelectedOptionValue() == 'Y')
      allEdits.push({ type: 'attribute', data: { allowed: 'Y' }, relation_id: 'kids' });

    // Three cases: park chosen (this.state.areaId > 0), free-form chosen (this.state.areaId == -1), no park (else)
    const areaIdWas = this.props.trail.area ? this.props.trail.area.id : null;
    if (this.state.areaId > 0) {
      if (this.state.areaId != areaIdWas) allEdits.push({ type: 'area', relation_id: this.state.areaId, data: { comment: '' } });
    } else if (this.state.areaId == -1 || this.state.nearbyParks.length == 0) {
      if (this.refs.areaFreeForm) {
        const freeFormArea = this.refs.areaFreeForm.value;
        if (freeFormArea != '') {
          let data = {
            name: freeFormArea,
            latitude: this.state.location.latitude,
            longitude: this.state.location.longitude
          };
          // Use useMapAsRoute location in preference to a default Kansas location
          if (
            data.latitude == CENTER_LOWER_48[0] &&
            data.longitude == CENTER_LOWER_48[1] &&
            this.props.useMapAsRoute &&
            this.props.useMapAsRoute.location
          ) {
            data.latitude = +this.props.useMapAsRoute.location.latitude;
            data.longitude = +this.props.useMapAsRoute.location.longitude;
          }
          allEdits.push({
            type: 'new_area',
            data
          });
        }
      }
    } else if (areaIdWas) allEdits.push({ type: 'area', relation_id: null, data: { comment: 'area_id null' } });

    if (!this.props.isPendingTrail || this.props.trail.canEdit) {
      // Four cases: City chosen (this.state.cityId > 0); Free-form chosen (this.state.cityId == -1 or no nearby cities found);
      // Admin-only "clear and regeocode" (this.state.cityId == -2); Else--should not occur
      const cityIdWas = this.props.trail.location && this.props.trail.location.city_id ? this.props.trail.location.city_id : null;
      if (this.state.cityId > 0) {
        if (this.state.cityId != cityIdWas) allEdits.push({ type: 'city_id', relation_id: this.state.cityId, data: { comment: '' } });
      } else if (this.state.cityId == -2) {
        allEdits.push({ type: 'city_id', relation_id: null, data: { comment: '' } });
      } else if (this.state.cityId == -1 || this.state.nearbyCities.length == 0) {
        if (this.refs.cityFreeForm) {
          const regionAndCountry = this.refs.regionAndCountry.getSelectedValues();
          const regionId = regionAndCountry.regionId === null ? 0 : regionAndCountry.regionId;
          const freeFormCity = this.refs.cityFreeForm.value;
          if (freeFormCity != '')
            allEdits.push({
              type: 'new_city',
              data: {
                name: freeFormCity,
                latitude: this.state.location.latitude,
                longitude: this.state.location.longitude,
                region_id: regionId,
                country_id: regionAndCountry.countryId
              }
            });
        }
      }
    }

    // Verified Route (if drawn)
    const editData = this.refs.verifiedRouteContribute.getNewEditData();
    if (editData) allEdits.push(editData);

    return allEdits;
  },
  getNameValue() {
    return this.state.name;
  },
  getRouteTypeValue() {
    return this.refs.routeType.getSelectedOptionValue();
  },
  metersToMiles(length, inverse) {
    return Math.round(length * METERS_TO_MILES * 100) / 100;
  },
  metersToFormattedUserUnits(length) {
    return MapStatsUtil.metersToFormattedUserUnits(length, 2, this.props.displayMetric, this.props.languageRegionCode);
  },
  handleParkResults(content) {
    const parks = [];
    let areaInResults = false;
    content.hits.forEach((park, idx) => {
      parks.push([park.ID, `${park.name} (${this.metersToFormattedUserUnits(park._rankingInfo.geoDistance)})`]);
      if (this.state.areaId && park.ID == this.state.areaId) areaInResults = true;
    });
    // If our current park is not in list returned by Algolia, append it now:
    if (this.state.areaId && this.state.areaId != -1 && !areaInResults) parks.push([this.state.areaId, this.state.areaText]);
    this.setState({ nearbyParks: parks });
  },
  createAreaOption(park) {
    return <option value={park[0]}>{park[1]}</option>;
  },
  handleCityResults(content) {
    const cities = [];
    let cityInResults = false;
    content.hits.forEach((city, idx) => {
      if (city.objectID.substring(0, 6) != 'cityo-') return;
      cities.push([city.ID, `${city.name} (${this.metersToFormattedUserUnits(city._rankingInfo.geoDistance)})`, city.state_name]);
      if (this.state.cityId && city.ID == this.state.cityId) cityInResults = true;
    });
    // If our current city is not in list returned by Algolia, append it now:
    if (this.state.cityId && this.state.cityId > 0 && !cityInResults) cities.push([this.state.cityId, this.state.cityText, this.state.cityLocation]);
    this.setState({ nearbyCities: cities });
  },
  createCityOption(city) {
    return (
      <option key={city[0]} value={city[0]}>
        {city[1]}
      </option>
    );
  },
  convertDifficultyRating(dr) {
    if (!dr) return null;
    if (dr < 3) return 1;
    if (dr < 5) return 3;
    if (dr < 7) return 5;
    if (dr < 9) return 7;
    return null;
  },
  getDogsValue(features) {
    let value = null;
    if (Object.keys(features).indexOf('dogs-leash') >= 0) value = 'L';
    else if (Object.keys(features).indexOf('dogs-no') >= 0) value = 'N';
    else if (Object.keys(features).indexOf('dogs') >= 0) value = 'Y';
    return value;
  },
  handleObjectSelected(obj) {
    let objName;
    let zoom = 12;
    let areaId = null;
    if (obj.objectID.indexOf('city') >= 0) {
      objName = obj.name[1];
    } else if (obj.objectID.indexOf('area') >= 0) {
      objName = obj.name;
      areaId = obj.ID;
    } else {
      objName = obj.name;
    }
    if (obj.objectID.indexOf('state') >= 0) {
      zoom = 8;
    }

    // If we have a geolocation for the object use it
    // Otherwise use the calculated name to geocode the location
    if (obj._geoloc != null) {
      this.props.messagingChannel.publish('edit.change_lat_lng', [obj._geoloc.lat, obj._geoloc.lng, zoom]);
      if (areaId) {
        this.setState({ areaId, areaText: objName });
      } else {
        // clear any selected park if we are being taken to a new Place
        this.setState({ areaId: null, areaText: null });
      }
      this.algoliaParksAndCityQueryLatLng(obj._geoloc.lat, obj._geoloc.lng);
    } else {
      if (!areaId) {
        this.setState({ areaId: null, areaText: null });
      }
      $.ajax({
        url: `https://api.mapbox.com/v4/geocode/mapbox.places/${objName}.json?access_token=pk.eyJ1IjoiYWxsdHJhaWxzIiwiYSI6IkZGaGhGLWsifQ.Fl0FrDM8-xonRV6x2HFqcw`,
        success: data => {
          const [lng, lat] = data.features[0].center;
          this.props.messagingChannel.publish('edit.change_lat_lng', [lat, lng, zoom]);
          this.algoliaParksAndCityQueryLatLng(lat, lng);
        }
      });
    }
  },
  renderNameInput() {
    if (this.props.allowNameEditing) {
      return (
        <>
          <span className="field-name" data-testid="nameContributeTitle">
            <FormattedMessage defaultMessage="Name" />
            {` (${this.getTrailNameLength()})`}
          </span>
          <input
            id="name"
            className="text"
            data-testid="nameContribute"
            maxLength={150}
            defaultValue={this.state.name}
            onBlur={this.handleTrailNameBlur}
            onChange={this.handleTrailNameChange}
          />
        </>
      );
    }
    return (
      <div>
        <span className="field-name" data-testid="nameContributeTitle">
          <FormattedMessage defaultMessage="Name" />
          {` (${this.getTrailNameLength()})`}
        </span>
        <input id="name" disabled="disabled" ref="name" className="text short" maxLength={150} defaultValue={this.state.name} />
        <a className="name-edit-link" href={`/edit-translations?table=trails&column_name=name&id=${this.props.trail.id}`} target="_blank">
          <FormattedMessage defaultMessage="Edit name" />
        </a>
      </div>
    );
  },
  handleTrailNameBlur() {
    if ((this.props.languageRegionCode === 'en-US' || this.props.languageRegionCode === 'en-GB') && this.state.name.indexOf('Trial') > -1) {
      // Don't translate this! It doesn't make sense for non-English languages
      alert('This trail name contains the word "Trial" instead of the word "Trail". Please ignore this message if this was intentional.');
    }
    return true;
  },
  handleTrailNameChange(e) {
    this.setState({ name: e.target.value });
  },
  handleUploadToggle() {
    this.setState({ uploadFormVisible: !this.state.uploadFormVisible });
  },
  handleUploadCancelClick() {
    this.setState({ uploadFormVisible: false });
  },
  getTrailNameLength() {
    if (!this.state.name) {
      return 0;
    }
    return this.state.name.replace(/\s*\[CLOSED\]\s?|\s*\[PRIVATE PROPERTY\]\s?|\s*\[CLOSED PRIVATE PROPERTY\]\s?|/g, '').length;
  },
  handleUploadSuccess(newMap) {
    this.setState({ uploadFormVisible: false }, () => {
      this.props.handleMapChange(newMap);
    });
  },
  handleAreaSelect(area) {
    const areaDistanceTo = turfDistance(pointItemToLngLat(this.state), pointItemToLngLat(area)) * 1000;
    const areaText = `${area.name} (${this.metersToFormattedUserUnits(areaDistanceTo)})`;
    this.setState({ areaId: area.ID, areaText });
  },
  enableNewParkClick() {
    this.setState({ areaId: -1, areaText: this.props.intl.formatMessage({ defaultMessage: 'New park' }) });
  },
  clearSelectedPark() {
    this.setState({ areaId: undefined, areaText: undefined });
  },
  renderTextAreaInput(title, ref, dataTestId, defaultValue, handleChange = null) {
    return (
      <div className="edit-field xlate-none">
        <span className="field-name wrap" data-testid={`${dataTestId}-title`}>
          {title}
        </span>
        <textarea className="text" ref={ref} data-testid={`${dataTestId}-value`} defaultValue={defaultValue} onChange={handleChange} rows="2" />
      </div>
    );
  },
  getAdminNotes() {
    let key_points = '';
    if (this.props.trail && this.props.trail.trailDetail) {
      key_points = this.props.trail.trailDetail.key_points;
    }
    return key_points;
  },
  renderAdminNotesSection() {
    if (!this.props.adminUser) {
      return null;
    }
    return this.renderTextAreaInput('Admin Notes', 'key_points', 'AdminNotes', this.getAdminNotes());
  },
  getDescription() {
    let description = '';
    if (this.props.trail && this.props.trail.trailDetail) {
      // Note that we intentionally filter out undefined but not null
      // null indicates the field exists on the trail but is currently empty
      // and should be considered present for the purposes of chosing which field to display
      description = [
        this.props.trail.trailDetail.description_source_without_alerts,
        this.props.trail.trailDetail.description_without_alerts,
        this.props.trail.trailDetail.description_source,
        this.props.trail.trailDetail.description,
        description
      ].find(value => ![undefined].includes(value));
    }
    return description;
  },
  renderDescriptionSection() {
    if (!this.props.adminUser && !this.props.trail.canEdit) {
      return null;
    }
    const length = this.state.description?.length || 0;
    const title = `${this.props.intl.formatMessage({ defaultMessage: 'Description' })} (${length})`;
    const handleChange = event => {
      this.setState({ description: event.target.value });
    };

    return this.renderTextAreaInput(title, 'description', 'Description', this.state.description, handleChange);
  },
  renderMonthOptions() {
    const options = Object.keys(monthMessages).map((messageKey, index) => {
      return (
        <option value={index + 1} key={`months-${index}`}>
          {this.props.intl.formatMessage(monthMessages[messageKey])}
        </option>
      );
    });
    return options;
  },
  renderParkEditField() {
    // null input
    let nlInput;
    if (this.state.areaId == -1 || this.state.nearbyParks.length == 0) {
      nlInput = (
        <input
          ref="areaFreeForm"
          className="second-line-text text"
          placeholder={this.props.intl.formatMessage({ defaultMessage: 'Enter new park name' })}
        />
      );
    }
    // clear button
    let clearBtn;
    if (this.state.areaId) {
      clearBtn = (
        <span>
          {' '}
          -{' '}
          <a onClick={this.clearSelectedPark}>
            <FormattedMessage defaultMessage="Clear" />
          </a>
        </span>
      );
    }
    // lat/lng
    let defaultLatLng = [this.state.location.latitude, this.state.location.longitude];
    let weightResults = false; // if a trail head has been selected, order parks by proximity (not popularity)
    // use center of map if the defaultLatLng is set to center coordinates of U.S. (aka hasn't been set to any value yet)
    if (defaultLatLng && defaultLatLng[0] == CENTER_LOWER_48[0] && defaultLatLng[1] == CENTER_LOWER_48[1] && this.props.mapCenter) {
      defaultLatLng = this.props.mapCenter;
      weightResults = true;
    }
    let label;
    if (this.state.areaText || clearBtn) {
      label = (
        <label>
          {this.state.areaText}
          {clearBtn}
        </label>
      );
    }
    // park algolia search box selection
    const parkSelection = (
      <div className="contains-search-box">
        {label}
        <AlgoliaSearchBox
          mobileBrowser={false}
          languageRegionCode={this.props.languageRegionCode}
          typeSubset={['area']}
          placeholderText={this.props.intl.formatMessage({ defaultMessage: 'Select a park' })}
          handleAreaSelect={this.handleAreaSelect}
          defaultLatLng={defaultLatLng}
          displayDistanceToLatLng
          displayMetric={this.props.displayMetric}
          weightResults={weightResults}
          page={PARK_SELECTION}
          intl={this.props.intl}
        />
        {nlInput}
      </div>
    );
    // parkEditLink
    const newBtn = (
      <a onClick={this.enableNewParkClick}>
        <FormattedMessage defaultMessage="New" />
      </a>
    );
    let editBtn;
    let parkEditLink = <span>({newBtn})</span>;
    if (this.state.areaId && this.props.trail.canEdit) {
      const parkLink = `/merge-locations?area_id=${this.state.areaId}`;
      editBtn = (
        <a href={parkLink} target="_blank">
          <FormattedMessage defaultMessage="Edit" />
        </a>
      );
      parkEditLink = (
        <div>
          ({newBtn} / {editBtn})
        </div>
      );
    }
    // edit-field
    return (
      <div className="edit-field">
        <span className="field-name">
          <FormattedMessage defaultMessage="Park" /> {parkEditLink}
        </span>
        {parkSelection}
      </div>
    );
  },

  // Code extracted from AttributeMixin
  handleActivitySelection(activity) {
    const acts = this.state.checkedActivities;
    if (Object.keys(acts).indexOf(activity.uid) >= 0) {
      acts[activity.uid] = null;
      delete acts[activity.uid];
    } else {
      acts[activity.uid] = activity;
    }
    this.setState({ checkedActivities: acts });
  },
  handleFeatureSelection(feature) {
    const feats = this.state.checkedFeatures;
    if (Object.keys(feats).indexOf(feature.uid) >= 0) {
      feats[feature.uid] = null;
      delete feats[feature.uid];
    } else {
      feats[feature.uid] = feature;
    }
    this.setState({ checkedFeatures: feats });
  },
  handleObstacleSelection(obstacle) {
    const obs = this.state.checkedObstacles;
    if (Object.keys(obs).indexOf(obstacle.uid) >= 0) {
      obs[obstacle.uid] = null;
      delete obs[obstacle.uid];
    } else {
      obs[obstacle.uid] = obstacle;
    }
    this.setState({ checkedObstacles: obs });
  },
  createAttributeInput(activity, checkedAttributes, handleAttributeSelection, intlMessages) {
    let classes = `xlate-none btn-slim brown activity-select`;
    let text = activity.name.toLowerCase();
    try {
      text = this.props.intl.formatMessage(intlMessages[activity.name.toUpperCase().replace(/ /g, '_')]).toLowerCase();
    } catch (error) {
      // Do nothing, default back to activity.name
    }
    if (Object.keys(checkedAttributes).indexOf(activity.uid) >= 0) {
      classes += ' selected';
      text += ' ×';
    }
    return (
      <a className={classes} data-testid={text} onClick={handleAttributeSelection.bind(null, activity)}>
        {text}
      </a>
    );
  },
  createActivityInput(activity) {
    return this.createAttributeInput(activity, this.state.checkedActivities, this.handleActivitySelection, FILTER_ACTIVITIES_STRINGS);
  },
  createFeatureInput(feature) {
    return this.createAttributeInput(feature, this.state.checkedFeatures, this.handleFeatureSelection, FILTER_FEATURE_TYPES_STRINGS);
  },
  createAccessInput(feature) {
    return this.createAttributeInput(feature, this.state.checkedFeatures, this.handleFeatureSelection, FILTER_ACCESS_STRINGS);
  },
  createObstacleInput(obstacle) {
    return this.createAttributeInput(obstacle, this.state.checkedObstacles, this.handleObstacleSelection, FILTER_OBSTACLES_STRINGS);
  },
  renderUploadModal() {
    return (
      <ActivityUploadModal
        closeModal={this.handleUploadCancelClick}
        handleRouteUpload={this.handleUploadSuccess}
        context={this.props.context}
        routeMode
        createAsMap
        systemOwned
      />
    );
  },

  render() {
    const activitySelection = this.state.allActivities.map(this.createActivityInput);
    const featureSelection = this.state.allFeatures.map(this.createFeatureInput);
    const accessibilitySelection = this.state.allAccessibility.map(this.createAccessInput);
    const obstacleSelection = this.state.allObstacles.map(this.createObstacleInput);

    let adminCityEditLink = null;

    if (this.state.cityId && this.props.trail.canEdit) {
      const cityLink = `/merge-locations?city_id=${this.state.cityId}`;
      adminCityEditLink = (
        <span>
          (
          <a href={cityLink} target="_blank">
            <FormattedMessage defaultMessage="Edit" />
          </a>
          )
        </span>
      );
    }

    let cityAndRegionDiv = null;
    let lengthDiv = null;
    let routeInstructions = null;

    if (!this.props.isPendingTrail || this.props.trail.canEdit) {
      const cityOptions = this.state.nearbyCities.map(this.createCityOption);
      if (this.state.nearbyCities.length > 0)
        cityOptions.unshift(
          <option key="" value="">
            {this.props.intl.formatMessage({ defaultMessage: 'Select a city:' })}
          </option>
        );
      cityOptions.push(
        <option key="-1" value="-1">
          {this.props.intl.formatMessage({ defaultMessage: 'Add new city' })}
        </option>
      );
      if (this.props.trail.canEdit)
        cityOptions.push(
          <option key="-2" value="-2">
            Clear and regeocode city
          </option>
        );
      let regionCountryDiv;
      if (this.state.cityId == -2) {
        regionCountryDiv = (
          <p className="rev-geocode-txt xlate-none">
            <FormattedMessage defaultMessage="Trailhead's location:" /> {this.state.geocodedCityText}
          </p>
        );
      } else if (this.state.cityId == -1 || this.state.nearbyCities.length == 0) {
        regionCountryDiv = (
          <div>
            <input ref="cityFreeForm" className="second-line-text text" />
            <div>
              <span className="field-name xlate-none">
                <FormattedMessage defaultMessage="Region" />
              </span>
              <RegionAndCountrySelect
                ref="regionAndCountry"
                initialRegion={this.props.currentCity ? this.props.currentCity.state : null}
                initialCountry={this.props.currentCity ? this.props.currentCity.country : null}
              />
            </div>
          </div>
        );
      } else {
        let adminStateEditLink = null;
        if (this.state.cityId && this.props.trail.canEdit) {
          const link = `/merge-locations?state_of_city_id=${this.state.cityId}`;
          adminStateEditLink = (
            <span>
              (
              <a href={link} target="_blank">
                <FormattedMessage defaultMessage="Edit" />
              </a>
              )
            </span>
          );
        }
        regionCountryDiv = (
          <div>
            <span className="field-name xlate-none">
              <FormattedMessage defaultMessage="Region" /> {adminStateEditLink}
            </span>
            <input className="text" readOnly value={this.state.cityLocation} />
          </div>
        );
      }

      cityAndRegionDiv = (
        <div className="edit-field">
          <span className="field-name xlate-none">
            <FormattedMessage defaultMessage="City" /> {adminCityEditLink}
          </span>
          <div>
            <select className="xlate-none" id="city" ref="city" onChange={this.handleCityChange} value={this.state.cityId ? this.state.cityId : ''}>
              {cityOptions}
            </select>
            {regionCountryDiv}
          </div>
        </div>
      );

      if (this.props.displayMetric) {
        lengthDiv = (
          <div className="edit-field">
            <span className="field-name">
              <FormattedMessage defaultMessage="Distance" />
            </span>
            <input id="length" ref="length" className="text half" defaultValue={(this.props.trail.trailGeoStats.length / 1000.0).toFixed(2)} />
            <span className="faded">
              <FormattedMessage defaultMessage="Distance" /> (<FormattedMessage defaultMessage="in kilometers" />)
            </span>
          </div>
        );
      } else {
        lengthDiv = (
          <div className="edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Distance" />
            </span>
            <input id="length" ref="length" className="text half" defaultValue={MapStatsUtil.metersToMiles(this.props.trail.trailGeoStats.length)} />
            <span className="faded">
              <FormattedMessage defaultMessage="Distance" /> (<FormattedMessage defaultMessage="in miles" />)
            </span>
          </div>
        );
      }
    } else {
      routeInstructions = (
        <div id="verified-route-instructions xlate-none">
          <FormattedMessage defaultMessage="When adding new trails, we are specifically looking for trails that start and end at a parking area and are on public property. Our strong preference is for out-and-back or loop trails that begin and end in the same location, but of course some trails are through trails and they are welcome too. Please note that any suggested trail additions must first be evaluated by our moderators. This process may take a while depending on our ability to verify the information. To read more about how to draw a route click here.\n  If you have a recorded GPX file for the trail you can 'upload' that instead." />
        </div>
      );
    }

    let step_titles;
    let searchDividerDiv = null;
    let searchDiv = null;

    const uploadDiv = (
      <div>
        <div className="edit-field-or-divider xlate-none">
          <span>
            <FormattedMessage defaultMessage="or" />
          </span>
        </div>
        <div className="edit-field">
          <span className="field-name allow-lengthen xlate-none">
            <FormattedMessage defaultMessage="Upload route" />
          </span>
          <div className="option-button-group xlate-none">
            <button className="option-button" onClick={this.handleUploadToggle} data-testid="uploadButtonContribute">
              <FormattedMessage defaultMessage="Upload route" />
            </button>
          </div>
          <PortalModal isOpen={this.state.uploadFormVisible}>{this.renderUploadModal()}</PortalModal>
        </div>
      </div>
    );

    if (this.props.trail.id) {
      step_titles = [
        null,
        `${this.props.intl.formatMessage({ defaultMessage: 'Step 1' })} - ${this.props.intl.formatMessage({
          defaultMessage: 'Suggest a better route'
        })}`,
        `${this.props.intl.formatMessage({ defaultMessage: 'Step 2' })} - ${this.props.intl.formatMessage({
          defaultMessage: 'Edit trail information'
        })}`
      ];
    } else {
      step_titles = [
        `${this.props.intl.formatMessage({ defaultMessage: 'Step 1' })} - ${this.props.intl.formatMessage({
          defaultMessage: 'Find the starting location'
        })}`,
        `${this.props.intl.formatMessage({ defaultMessage: 'Step 2' })} - ${this.props.intl.formatMessage({
          defaultMessage: 'Draw/Upload the route'
        })}`,
        `${this.props.intl.formatMessage({ defaultMessage: 'Step 3' })} - ${this.props.intl.formatMessage({
          defaultMessage: 'Edit trail information'
        })}`
      ];
      searchDividerDiv = (
        <div className="edit-field-divider xlate-none">
          <span>{step_titles[0]}</span>
        </div>
      );
      searchDiv = (
        <div>
          <div className="edit-field">
            <span className="field-name xlate-none">
              <FormattedMessage defaultMessage="City or park" />
            </span>
            <div className="search-holder">
              <AlgoliaSearchBox
                handleTrailSelect={null}
                handleAreaSelect={this.handleObjectSelected}
                handleLocationSelect={this.handleObjectSelected}
                handleQueryStringSubmit={null}
                typeSubset={['area', 'place']}
                placeholderText={this.props.intl.formatMessage({ defaultMessage: 'Enter a city, park, or lat,long...' })}
                enterSelectsFirstMatch
                numResults={10}
                languageRegionCode={this.props.languageRegionCode}
                messagingChannel={this.props.messagingChannel}
                page={TRAIL_DETAILS}
                intl={this.props.intl}
              />
            </div>
          </div>
        </div>
      );
    }

    const adminNotesPresent = this.props.trail && this.props.trail.trailDetail && this.props.trail.trailDetail.key_points;

    return (
      <div id="trail-details-box" className="trail-details">
        <div>
          {searchDividerDiv}
          {searchDiv}
          <div className="edit-field-divider xlate-none">
            <span>{step_titles[1]}</span>
          </div>
          <div className="edit-field">
            {routeInstructions}
            <span className="field-name allow-lengthen xlate-none">
              <FormattedMessage defaultMessage="Draw route" />
            </span>
            <VerifiedRouteContributeItem
              adminUser={this.props.adminUser}
              displayMetric={this.props.displayMetric}
              forTrailDetails
              mapModel={this.props.useMapAsRoute}
              messagingChannel={this.props.messagingChannel}
              rapidRoute={this.props.rapidRoute}
              ref="verifiedRouteContribute"
              routeInfo={this.props.routeInfo}
              trail={this.props.trail}
              intl={this.props.intl}
            />
          </div>
          {uploadDiv}
          <div className="edit-field-divider xlate-none">
            <span>{step_titles[2]}</span>
          </div>
          {adminNotesPresent && this.renderAdminNotesSection()}
          <div className="edit-field xlate-none">{this.renderNameInput()}</div>
          {this.renderParkEditField()}
          {cityAndRegionDiv}
          {lengthDiv}
          <div className="edit-field xlate-none">
            <span className="field-name ellipse">
              <FormattedMessage defaultMessage="Route type" />
            </span>
            <OptionButtons
              ref="routeType"
              optionDefs={[
                { value: 'L', name: this.props.intl.formatMessage({ defaultMessage: 'Loop' }) },
                { value: 'O', name: this.props.intl.formatMessage({ defaultMessage: 'Out & back' }) },
                { value: 'P', name: this.props.intl.formatMessage({ defaultMessage: 'Point to point' }) }
              ]}
              initialValue={this.props.trail.routeType ? this.props.trail.routeType.uid : null}
            />
          </div>
          <div className="edit-field xlate-none">
            <span className="field-name ellipse">
              <FormattedMessage defaultMessage="Difficulty" />
            </span>
            <OptionButtons
              ref="difficultyRating"
              optionDefs={[
                { value: 1, name: this.props.intl.formatMessage({ defaultMessage: 'Easy' }) },
                { value: 3, name: this.props.intl.formatMessage({ defaultMessage: 'Moderate' }) },
                { value: 5, name: this.props.intl.formatMessage({ defaultMessage: 'Difficult' }) },
                { value: 7, name: this.props.intl.formatMessage({ defaultMessage: 'Strenuous' }) }
              ]}
              initialValue={this.convertDifficultyRating(this.props.trail.defaultActivityStats.difficulty)}
            />
          </div>
          <div className="edit-field xlate-none">
            <span className="field-name ellipse">
              <FormattedMessage defaultMessage="Usage" />
            </span>
            <OptionButtons
              ref="visitorUsage"
              optionDefs={[
                { value: 1, name: this.props.intl.formatMessage({ defaultMessage: 'Light' }) },
                { value: 2, name: this.props.intl.formatMessage({ defaultMessage: 'Moderate' }) },
                { value: 3, name: this.props.intl.formatMessage({ defaultMessage: 'Heavy' }) },
                { value: 4, name: this.props.intl.formatMessage({ defaultMessage: 'Extra heavy' }) }
              ]}
              initialValue={this.props.trail.defaultActivityStats.visitorUsage}
            />
          </div>
          <div className="edit-field xlate-none">
            <span className="field-name ellipse">
              <FormattedMessage defaultMessage="Season" />
            </span>
            <select
              data-testid="season-start"
              id="season-start"
              className="half"
              ref="seasonStart"
              defaultValue={this.props.trail.defaultActivityStats.seasonStart}
            >
              <option value="">-- {this.props.intl.formatMessage({ defaultMessage: 'Start' })} --</option>
              {this.renderMonthOptions()}
            </select>
            <select
              data-testid="season-end"
              id="season-end"
              className="half"
              ref="seasonEnd"
              defaultValue={this.props.trail.defaultActivityStats.seasonEnd}
            >
              <option value="">-- {this.props.intl.formatMessage({ defaultMessage: 'End' })} --</option>
              {this.renderMonthOptions()}
            </select>
          </div>
          <div className="activities edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Activities" />
            </span>
            <div className="activity-list">{activitySelection}</div>
          </div>
          <div className="features edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Features" />
            </span>
            <div className="feature-list">{featureSelection}</div>
          </div>
          <div className="obstacles edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Obstacles" />
            </span>
            <div className="obstacle-list">{obstacleSelection}</div>
          </div>
          <div className="edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Dogs" />
            </span>
            <OptionButtons
              ref="dogs"
              optionDefs={[
                { value: 'Y', name: this.props.intl.formatMessage({ defaultMessage: 'Dog friendly' }).toLowerCase() },
                { value: 'L', name: this.props.intl.formatMessage({ defaultMessage: 'Dogs on leash' }).toLowerCase() },
                { value: 'N', name: this.props.intl.formatMessage({ defaultMessage: 'No dogs' }).toLowerCase() }
              ]}
              initialValue={this.getDogsValue(this.state.checkedFeatures)}
            />
          </div>
          <div className="edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Accessible" />
            </span>
            <div className="feature-list">{accessibilitySelection}</div>
          </div>
          <div className="edit-field xlate-none">
            <span className="field-name">
              <FormattedMessage defaultMessage="Kids" />
            </span>
            <OptionButtons
              ref="kids"
              optionDefs={[{ value: 'Y', name: this.props.intl.formatMessage({ defaultMessage: 'Kid friendly' }).toLowerCase() }]}
              initialValue={Object.keys(this.state.checkedFeatures).indexOf('kids') >= 0 ? 'Y' : null}
            />
          </div>
          {this.renderDescriptionSection()}
          {!adminNotesPresent && this.renderAdminNotesSection()}
        </div>
      </div>
    );
  }
});

const TrailDetailsBoxIntlProvider = forwardRef((props, ref) => {
  const intl = useIntl();
  return <BaseTrailDetailsBox {...props} intl={intl} ref={ref} />;
});

const TrailDetailsBox = forwardRef((props, ref) => {
  return (
    <CustomProvider>
      <TrailDetailsBoxIntlProvider {...props} ref={ref} />
    </CustomProvider>
  );
});

export { TrailDetailsBox };
